import { Lock } from '@tink/core/src/components/atoms/Icons/Lock';
import { styled } from '../../../core/theme/styled';

export const StyledLock = styled(Lock).attrs({ role: 'presentation' })`
  fill: ${(props) => props.theme.configuration.secondaryTextColor};
`;
